<template>
  <div class="button-sm button-sm-repeat" :disabled="disabled">
    <div class="button-sm__btn button-sm__btn-repeat" :disabled="disabled">
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 4.5C11.5 4.5 8.5 4.5 5 4.5C4.83847 4.5 1 4.5 1 8.5C1 13 4.70237 13 5 13C8 13 10 13 13 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.5 8C12.8668 6.6332 13.6332 5.8668 15 4.5C13.6332 3.13317 12.8668 2.36683 11.5 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-button-sm-repeat',
  props: {
    disabled: Boolean,
    title: String,
    type: {
      type: String,
      default: 'repeat'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button-sm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &__btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $font_color_alt;
    height: 30px;
    width: 30px;
    border-radius: 3px;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    font-family: $font_main;
  }

  &__text {
    transition: .3s;
    margin-left: 10px;
  }

  &[disabled] {
    color: $color_deactive;
    pointer-events: none;

    .button-sm__btn {
      background: $color_deactive;
      box-shadow: none;
    }
  }
}

.button-sm {
  &__btn-repeat {
    background: $button_color_fifth;
    box-shadow: 0 2px 2px #13557C;
  }

  &__btn-create {
    background: $button_color;
    box-shadow: 0 2px 2px #C6523B;
  }

  &:hover {
    .button-sm__btn-repeat {
      box-shadow: none;
    }
  }

  &:active {
    .button-sm__btn-repeat {
      box-shadow: inset 0 2px 2px #13557C;
    }
  }
}
</style>
